// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"6dfc1371","787":"8d14ddf2"}[chunkId] + ".chunk.js";
};